import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Img from "gatsby-image";

//Componente para backgroundImage

export default function Image(props) {
  const { fileName, alt, imgStyles, style } = props;
//notas
  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile(filter: { absolutePath: { regex: "/images/" } }) {
            edges {
              node {
                relativePath
                childImageSharp {
                  fluid(quality: 75, maxWidth: 1200) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      `}
      render={(data) => {
        const image = data.images.edges.find((image) => {
          return image.node.relativePath.includes(fileName);
        });
        if (!image) return null;
        return (
          <Img
            imgStyle={imgStyles}
            style={style}
            alt={alt}
            fluid={image.node.childImageSharp.fluid}
          />
        );
      }}
    />
  );
}
